exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width: 960px) {\n.change-color-cta {\n    width: 100%;\n}\n}\n", ""]);

// exports
